import { Hidden } from "@material-ui/core";
import styled from "styled-components";
import React, { ReactNode, useEffect, useState } from "react";
import { Content } from "../pages";
import Navbar from "./Navbar";
import SidebarDrawer from "./SidebarDrawer";
import { SearchHeader } from "components/SearchHeader";
import { PageHeader } from "components/shared";
import { useRouter } from "hooks";
import Footer from "./Footer/index";
import DialogNewPass from "components/shared/Dialogs/DialogNewPass";
import { isUpdated } from "services/sessionService";

interface ILayout {
  children: ReactNode;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export default function Layout({ children }: ILayout) {
  const router = useRouter();
  const [updateStatus, setUpdateStatus] = useState<boolean>(false)

  const verUpdate = async () => {
    await isUpdated()
      .then(res => {
        const { ISUPDATED } = res.data
        setUpdateStatus(!!!ISUPDATED)
      });
  }

  const titleAndShow = () => {
    const path = router.location.pathname;

    switch (path) {
      case "/dashboard":
        return { title: "Dashboard", show: true };
      case "/encomendas":
        return { title: "Encomendas", show: true };
      case "/destinatarios":
        return { title: "Gerenciar Destinatários", show: true };
      case "/events":
        return { title: "Eventos", show: true };
      case "/instalacoes/status":
        return { title: "Painel de Controle", show: false };
      case "/business-model":
        return { title: "Business Model", show: false };
      case "/novodest":
        return { title: "Destinatários em cards", show: true };
      case "/correios":
        return { title: "Logs", show: true };
      case "/home":
        return { title: "Home", show: true };
      default:
        if (Object.keys(router.query)[0] === "idmcm") {
          return { title: "Painel de Controle / Status", show: false };
        }
        if (Object.keys(router.query)[0] === "id") {
          return { title: "Editar Destinatário", show: false };
        }
    }
  };

  useEffect(() => {
    verUpdate()
  }, [updateStatus])
  return (
    <>
      <Hidden mdUp>
        <Navbar />
      </Hidden>

      <Container>
        <Hidden smDown>
          <SidebarDrawer />
        </Hidden>
        <div style={{ width: "100%" }}>
          <Content>
            <PageHeader title={titleAndShow()?.title} />
            {titleAndShow()?.show &&
              <SearchHeader />
            }
            {children}
          </Content>
          <Footer />
        </div>
      </Container>

      <DialogNewPass
        open={updateStatus}
        setOpen={setUpdateStatus}
      />
    </>
  );
}
